import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React, { FC } from 'react';
import './action-button.scss';

type Props = {
    icon: IconDefinition,
    iconColor?: string,
    iconSize?: FontAwesomeIconProps["size"],
    buttonColor?: string,
    buttonText?: string,
    enabled?: boolean,
    buttonTextColor?: string,
    borderColor?: string,
    buttonWidth?: string,
    circular?: boolean,
    onClick?: () => void,
    id?: string,
    dataTestId?: string
}

export const ActionButton: FC<Props> = ({ icon, iconColor = 'white', iconSize = '1x', buttonColor = 'white', buttonText = '', enabled = true, buttonTextColor = 'White', borderColor = 'none', buttonWidth, circular = false, onClick = () => { }, id = "", dataTestId }) => {

    const buttonStyle = {
        backgroundColor: buttonColor,
        border: borderColor,
        width: buttonWidth ? buttonWidth : '110px',
        height: circular ? buttonWidth : '40px',
        borderRadius: circular ? '50%' : '15px'
    }

    return (
        <div id={id} className={'action-container'} >
            <div className={`action-button ${enabled ? '' : 'disabled'}`} style={buttonStyle} onClick={enabled ? onClick : undefined} data-testid={dataTestId}>
                <FontAwesomeIcon icon={icon as IconProp} color={iconColor} size={iconSize} />
                {buttonText &&
                    <div className={'action-text'} style={{ color: buttonTextColor }}>{buttonText}</div>
                }
            </div>
        </div>
    )
}